// extracted by mini-css-extract-plugin
export default {"container":"TableActions_container__XND8B","buttons":"TableActions_buttons__d0OGd"};